import React, { useState } from 'react';
import ForgotPasswordForm from '../../components/UI/Form/ForgotPasswordForm';
import SuccessModal from '../../components/UI/Modal/SuccessModal';
import { PrimaryButton } from "../../components/UI";
import { useNavigate } from 'react-router-dom';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [showSecureCode, setShowSecureCode] = useState(false);
    const { content } = useContentfulContext();

    return (
        <>
            <section>
                <div className="mx-auto flex flex-col md:flex-row items-center max-w-[75%] my-6">
                    <div className="p-8 flex flex-col lg:w-1/2 justify-center items-start text-center m-auto my-9">
                        <div className="space-y-4 md:space-y-6 w-full">
                            <h1 className="text-xl font-medium leading-tight tracking-tight text-gray-900 md:text-2xl">
                                {content.FORGOT_PASSWORD_CONTENT.title}
                            </h1>
                            <ForgotPasswordForm submitHandler={() => { setShowSecureCode(true) }}/>
                        </div>
                    </div>
                </div>
            </section>
            {showSecureCode && <SuccessModal title={content.FORGOT_PASSWORD_CONTENT.forgot_password_modal.title} hideModal={() => {
                setShowSecureCode(false);
                navigate('/');
            }}>
                <div className="px-6 py-6 lg:px-8 text-center">
                    <p className='font-medium text-primary-600 mb-4'>{content.FORGOT_PASSWORD_CONTENT.forgot_password_modal.description}</p>
                    <PrimaryButton handleClick={() => {
                        setShowSecureCode(false);
                        navigate('/');
                    }}>{content.FORGOT_PASSWORD_CONTENT.login_cta}</PrimaryButton>
                </div>
            </SuccessModal>
            }
        </>
    )
}

export default ForgotPassword;